<div class="dropdown">
    <!-- {{statusSelect}} -->
    <a data-bs-toggle="dropdown" (click)="chagedStatus()" *ngIf="(statusSelect != 5 && statusSelect != 6 && statusSelect != 7 && statusSelect != 8) && !(statusSelect == 1 && !departureCheckCompleted) && (dataUser.type_admin == 1 || dataUser.type_admin == 2 || dataUser.type_admin == 3); else noSelectStatus" aria-expanded="false" class="status_text">
        {{status_text}}
    </a>
    <ng-template #noSelectStatus>
        <a class="status_text">
            {{status_text}}
        </a>
    </ng-template>

    
</div>
